import apiClient from './client';

export const submitBugReport = async ({
  title,
  description,
  pageUrl,
  category,
  bugType,
  screenshot,
  technicalContext,
  questionContext,
  richContext,
  deckId,
  examId,
  questionId,
  levelSessionId,
  sessionId,
  reproSteps,
  expectedBehavior,
  actualBehavior,
}) => {
  const response = await apiClient.post('/api/bug-reports', {
    title,
    description,
    page_url: pageUrl,
    category,
    bug_type: bugType || null,
    screenshot: screenshot || null,
    technical_context: technicalContext || null,
    question_context: questionContext || null,
    rich_context: richContext || null,
    deck_id: deckId || null,
    exam_id: examId || null,
    question_id: questionId || null,
    level_session_id: levelSessionId || null,
    session_id: sessionId || null,
    repro_steps: reproSteps || null,
    expected_behavior: expectedBehavior || null,
    actual_behavior: actualBehavior || null,
  });
  return response.data;
};

export const getBugReports = async ({ status, limit = 50, skip = 0 } = {}) => {
  const params = { limit, skip };
  if (status) params.status = status;
  const response = await apiClient.get('/api/bug-reports', { params });
  return response.data;
};

export const getTeachingReports = async ({ status, limit = 50, offset = 0 } = {}) => {
  const params = { limit, offset };
  if (status) params.status = status;
  const response = await apiClient.get('/api/teaching-reports', { params });
  return response.data;
};

export const getQuestionReports = async ({ status, limit = 50 } = {}) => {
  const params = { limit };
  if (status) params.status = status;
  const response = await apiClient.get('/api/questions/review-queue', { params });
  return response.data;
};

export const updateBugReport = async (reportId, { status, adminNotes }) => {
  const response = await apiClient.patch(`/api/bug-reports/${reportId}`, {
    status: status || undefined,
    admin_notes: adminNotes || undefined,
  });
  return response.data;
};

export const deleteBugReport = async (reportId) => {
  const response = await apiClient.delete(`/api/bug-reports/${reportId}`);
  return response.data;
};

export const resolveTeachingReport = async (reportId, { resolution, actionTaken }) => {
  const response = await apiClient.post(`/api/teaching-reports/${reportId}/resolve`, {
    resolution,
    action_taken: actionTaken || null,
  });
  return response.data;
};

export const dismissTeachingReport = async (reportId, { reason }) => {
  const response = await apiClient.post(`/api/teaching-reports/${reportId}/dismiss`, {
    reason: reason || null,
  });
  return response.data;
};
